package devxertech.com.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SendEmailPayload(
    val to: String,
    val subject: String,
    val message: String,
    val recaptchaToken: String,
    val attachment: Attachment? = null,
)

@Serializable
data class Attachment(
    val filename: String,
    @SerialName("content_type")
    val contentType: String,
    val data: String,
)

@Serializable
data class SendEmailResponse(
    val success: Boolean,
    val message: String,
)